module.exports = __webpack_public_path__ + "img/shutdown.9ea14e96.png";